import validation from "@irati/utils/validation"

const phoneRegex = /^[0-9+\s()-]{7,15}$/
const niRegex = /^[A-Z]{2}\d{6}[A-Z]$/
const mobilePhoneRegex = /^(07\d{9})$/
const postCodeRegex = /^([A-Z][A-HJ-Y]?\d[A-Z\d]? ?\d[A-Z]{2}|GIR ?0A{2})$/

export const workplaceSchema = validation
  .string()
  .min(6, "Workplace name must be at least 6 characters long")
  .required("Workplace is required")

export const vivupPlaceOfWorkSchema = validation.string().required("Workplace is required")

export const employeeNumberSchema = validation
  .string()
  .min(6, "Employee number must be at least 6 characters long")
  .required("Employee number is required")

export const niNumberSchema = validation.string().min(6, "NI number must be at least 6 characters long").required("NI number is required")

export const vivupNiNumberSchema = validation.string().matches(niRegex, "Invalid NI number").required("NI number is required")

export const titleSchema = validation.string().min(2, "Title must be at least 2 characters long").required("Title is required")

export const firstNameSchema = validation
  .string()
  .min(3, "First name must be at least 3 characters long")
  .required("First name is required")

export const lastNameSchema = validation.string().min(3, "Last name must be at least 3 characters long").required("Last name is required")

export const dobDaySchema = validation.string().required("Please select a day")
export const dobMonthSchema = validation.string().required("Please select a month")
export const dobYearSchema = validation.string().required("Please select a year")

export const emailSchema = validation.string().email("Please enter a valid email address").required("Email address is required")

export const phoneNumberSchema = validation
  .string()
  .matches(phoneRegex, "Mobile number must be exactly 10 digits")
  .min(10, "Mobile number must be exactly 10 digits")
  .max(10, "Mobile number must be exactly 10 digits")
  .required("Mobile number is required")

export const mobileNumberSchema = validation
  .string()
  .matches(mobilePhoneRegex, "Invalid mobile phone number")
  .required("Mobile number is required")

export const addressLine1Schema = validation
  .string()
  .min(3, "Address line 1 must be at least 3 character long")
  .required("Address line 1 is required")

export const townSchema = validation.string().min(3, "City must be at least 3 character long").required("town is required")

export const countySchema = validation.string().min(3, "State must be at least 3 character long").required("State is required")

export const zipCodeSchema = validation.string().min(3, "Zip code must be at least 3 character long").required("Zip code is required")

export const ukPostCodeSchema = validation
  .string()
  .matches(postCodeRegex, "Invalid post code")
  .required("Post code is required")
  .uppercase()

export const TandCSchemma = validation
  .bool()
  .oneOf([true], "You must accept the Terms and Conditions")
  .required("You must accept the Terms and Conditions")
